import { useQuery } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";

export default function useOpenaiConfig() {
  return useQuery({
    queryKey: ["configurations", "openai"],
    queryFn: async () => {
      const response = await axiosGet("/configurations/allAIConfigs");
      return response.data.data;
    },
    staleTime: Infinity,
  });
}
